import { enc, SHA256 } from 'crypto-js';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from "@angular/router";
import { ApiService } from "../shared/api.service";
import { Common } from '../shared/common';
import {
  Poll,
  PollStatus,
  VotingEvent
} from '../shared/model/poll.model';
import * as interfaceEnums from '../poll-detail/interfaceEnums';
import { ErrorList } from '../poll-detail/interfaceEnums';

/**
 * Composant de test pemettant de mettre en place un affcihage dynamique.
 * ==> Il devra correspondre à votre composant de VOTE par exemple.
 */
@Component({
  selector: 'app-dynamic-display',
  templateUrl: './dynamic-display.component.html',
  styleUrls: ['./dynamic-display.component.less']
})
export class DynamicDisplayComponent implements OnInit {
  isMobile: boolean;
  lastname: any;
  firstname: any;
  pollId: string;
  privateKey: string;
  email: any;
  isClose: boolean = false;
  notYetOpen = false;
  votingType: string;
  isLive: boolean;

  // 2FA
  isValidated = true;
  isValidatedPass = true;
  isValidatedSms = true;
  noMoreSMS = false;
  userPhoneNumber: any;
  userRetriesRemaining: number;
  smsSent = false;
  isValidationCodeError = false;
  isWrongPhoneError = false;
  validationErrorObj: AuthError = null;

  //
  electionDataJson: VotingEvent = null;
  testElectionDataJson: VotingEvent = null;
  liveActiveResolution = 0; // useless ?
  numberOfVote: number[] = [];
  participation: number = 0;
  dateString: string = '';
  startDate: string = '';
  formattedStartDate: string = '';
  formattedEndDate: string = ''
  validationApiBlocker: boolean = false;
  opened: boolean = false;
  status: PollStatus = PollStatus.list;
  votedStatuses: boolean[] = [];
  validation: string = '';
  forceRefreshVotedMessage: boolean = false;
  errorMessage: string;
  errorTitle: string;
  errorCanRetry: boolean;
  votingProof: string = '';
  activePoll: Poll;
  enableTestPopup: boolean = false;
  disableTestPopup: boolean = false;
  isTestActive: boolean = false;
  canHaveTestMode = true;

  constructor(
    private route: ActivatedRoute,
    private apiService: ApiService,
    private common: Common
  ) { }

  activateTestModePopup($event: boolean) {
    if ($event) {
      this.getTestPollData();
      this.enableTestPopup = true;
    }

    else
      this.disableTestPopup = true;
  }

  enableTest($event: boolean) {
    this.enableTestPopup = false;
    this.isTestActive = true;
  }

  disableTest($event: boolean) {
    this.disableTestPopup = false;
    this.isTestActive = false;
  }

  getUserLanguage(): string {
    const languageKey = 'userLanguage';
    return navigator.language || navigator[languageKey];
  }

  getMessageDisplayLanguage(): string {
    switch (this.getUserLanguage().substring(0, 2)) {
      case 'fr': return 'fr';
      case 'es': return 'es';
      default: return 'en';
    }
  }

  setupPhone(phone: string) {
    this.apiService.changePhone(this.validation, phone, this.pollId).subscribe((res) => {
      this.setup2FA();
      return true;
    }, (err: any) => {
      this.isWrongPhoneError = true;
      return false;
    });
  }

  validateSMS($event: string) {
    this.isValidationCodeError = false;
    this.apiService.validateVoterSMS(this.pollId, this.privateKey, $event).subscribe((res) => {
      this.isValidatedSms = false;
      this.setup2FA();
    },
      (err: any) => {
        const status = err.status;
        let counter: number = null;
        let time: Date = null;
        if (status === 400 && err.error.error != null) {
          const errorMsg = err.error.error as string;
          if (errorMsg.includes('Incorrect validation code, attempts so far: ')) {
            const attempts = parseInt(err.error.error.replace('Incorrect validation code, attempts so far: ', ''), 10);
            counter = attempts >= 5 ? 0 : 5 - attempts;
          }
        }
        if (status === 429 && err.error.error != null) {
          const errorMsg = err.error.error as string;
          const errorSplit = errorMsg.split(' ');
          const dateStr = errorSplit[errorSplit.length - 1];
          time = new Date(dateStr);
        }
        this.validationErrorObj = new AuthError(status, counter, time);
        this.isValidationCodeError = true;
      });
  }

  resendSMS() {
    this.apiService.getSMS(this.pollId, this.privateKey).subscribe((res) => {
      this.userRetriesRemaining--;
    },
      (err: any) => {
        console.log(err);
        this.noMoreSMS = true;
      });
  }

  sendFirstSms() {
    this.apiService.sendInitialSms(this.pollId, this.privateKey).subscribe((res) => {
      this.userRetriesRemaining--;
    },
      (err: any) => {
        console.log(err);
        this.noMoreSMS = true;
      });
  }

  validatePassword($event: string) {
      this.isValidationCodeError = false;
      const pass = SHA256($event).toString(enc.Hex);
      this.apiService.validateVoterPass(this.pollId, this.privateKey, pass).subscribe((res) => {
        this.isValidatedPass = true;
        this.setup2FA();
      },
        (err: any) => {
          const status = err.status;
          let counter: number = null;
          let time: Date = null;
          if (status === 400 && err.error.error != null) {
            const errorMsg = err.error.error as string;
            if (errorMsg.includes('Incorrect validation code, attempts so far: ')) {
              const attempts = parseInt(err.error.error.replace('Incorrect validation code, attempts so far: ', ''), 10);
              counter = attempts >= 5 ? 0 : 5 - attempts;
            }
          }
          if (status === 429 && err.error.error != null) {
            const errorMsg = err.error.error as string;
            const errorSplit = errorMsg.split(' ');
            const dateStr = errorSplit[errorSplit.length - 1];
            time = new Date(dateStr);
          }
          this.validationErrorObj = new AuthError(status, counter, time);
          this.isValidationCodeError = true;
        });
    }

  getVotingError(reason: string, optional: string = null) {
    let messageList: ErrorList;
    switch (this.getMessageDisplayLanguage()) {
      case 'fr': {
        messageList = interfaceEnums.votingErrors.fr;
        break;
      }
      case 'es': {
        messageList = interfaceEnums.votingErrors.es;
        break;
      }
      default: messageList = interfaceEnums.votingErrors.en;
    }
    switch (reason) {
      case 'closed': {
        this.errorTitle = messageList.closed.title;
        this.errorCanRetry = messageList.closed.canRetry;
        this.errorMessage = messageList.closed.description;
        break;
      }
      case 'retry': {
        this.errorTitle = messageList.retry.title;
        this.errorCanRetry = messageList.retry.canRetry;
        this.errorMessage = messageList.retry.description;
        break;
      }
      case 'blankVote': {
        this.errorTitle = messageList.blankVote.title;
        this.errorCanRetry = messageList.blankVote.canRetry;
        this.errorMessage = messageList.blankVote.description;
        break;
      }
      case 'voted': {
        this.errorTitle = messageList.voted.title;
        this.errorCanRetry = messageList.voted.canRetry;
        this.errorMessage = optional === null ? messageList.voted.description : messageList.votedAt.description + optional;
        break;
      }
    }
  }

  createAlreadyVotedError(date: string = null) {
    this.status = PollStatus.alreadyVoted;
    this.getVotingError('voted', date);
  }

  shouldNotUpdateStatusOnRefresh(): boolean {
    return (this.status !== PollStatus.voted && this.status !== PollStatus.voteFailed) && this.liveActiveResolution !== -1;
  }

  getVotedStatus() {
    this.apiService.getVotedStatus(this.pollId, this.validation).subscribe((res: Array<Date>) => {
      this.votedStatuses = res.map(r => r !== null);
      if (this.votedStatuses.indexOf(false) === -1 || (this.isLive && res[this.liveActiveResolution])) {
        if ((!this.isLive || (this.isLive && this.shouldNotUpdateStatusOnRefresh()))) {
          const options: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'long', day: 'numeric' };
          const dateString = new Date(res[this.liveActiveResolution]).toLocaleTimeString('fr-FR', options);
          if (this.status !== PollStatus.voted) { this.createAlreadyVotedError(dateString); }
        }
      } else {
        if (this.isLive && this.forceRefreshVotedMessage) { this.status = PollStatus.list; }
      }
    });
  }

  getVoterInfo() {
    this.apiService.getVoterInfo(this.pollId, this.privateKey).subscribe((res) => {
      this.userPhoneNumber = res.phone;
      this.userRetriesRemaining = res.retries;
      this.smsSent = res.smsSent;
    },
      (err: any) => {
        console.log(err);
        // if (err.error.error)
        this.noMoreSMS = true;
      });
  }

  setup2FA() {
    this.apiService.get2FAStatus(this.pollId, this.privateKey).subscribe((res) => {
      this.isValidated = true;
    },
      (err: any) => {
        // IF THE ERROR IS DIFFERENT, THE NORMAL PAGE (but empty) IS DISPLAYED
        if (err.status === 426) {
          if (err.error) {
            if (err.error.is2FA != null) { this.isValidatedSms = err.error.is2FA; }
            if (err.error.password != null) { this.isValidatedPass = err.error.password.length < 4; }
          }
          this.isValidated = false;
          this.getVoterInfo();
        }
      });
  }

  getTestPollData() {
    this.apiService.getTestPoll(this.pollId, this.validation).subscribe((res: VotingEvent) => {
      this.testElectionDataJson = res;
      if (this.testElectionDataJson.isLive) {
        this.liveActiveResolution = this.testElectionDataJson.rounds.findIndex(r => r.opened === true);
      }
      this.numberOfVote = [];
      this.isLive = res.isLive;
      this.participation = Math.round(
        (this.testElectionDataJson.votes / this.testElectionDataJson.voters) * 100
      );
      this.votingType = res.type;
      if (!this.validationApiBlocker && (this.testElectionDataJson.is2FA || (this.testElectionDataJson.password !== null && this.testElectionDataJson.password.length > 3))) {
        this.validationApiBlocker = true;
        this.setup2FA();
      }

      if (this.testElectionDataJson.rounds.length > 1 && !this.isLive) {
        this.status = PollStatus.eventList;
      }
      if (res.isFinished) {
        if (res.shareResults) {
          window.location.href = window.location.origin + '/poll/' + this.pollId + '/results';
        }
        else { this.status = PollStatus.completed; }
      }
      this.opened = res.opened;
      if (res.opened || res.pollPlanningStatus === 'AssessorTesting') {
        this.getVotedStatus();
      }
      if (res.image.length > 0) {
          const logo = document.getElementById('v8te-logo') as HTMLImageElement;
          const link = document.getElementById('v8te-url-image') as HTMLElement;
          if (link) {
            link.removeAttribute('href');
          }
          if (logo) {
            logo.src = res.image;
            logo.style.width = '200px';
            logo.style.maxHeight = '200px';
            logo.style.marginTop = '24px';
          }
      }
    });
  }

  getPollData() {
    this.apiService.getPoll(this.pollId, this.validation).subscribe((res: VotingEvent) => {
      this.electionDataJson = res;

      if (this.electionDataJson.isLive) {
        this.liveActiveResolution = this.electionDataJson.rounds.findIndex(r => r.opened === true);
      }
      // this.setPollRound(this.liveActiveResolution);
      // if (this.liveActiveResolution != -1 && res.rounds[this.liveActiveResolution].displayedQuestions[0].listImages[0] != "null"
      //     && res.rounds[this.liveActiveResolution].displayedQuestions[0].listImages[0] != undefined) {
      //       if (res.rounds[this.liveActiveResolution].results == null && res.type === 'live') {
      //         this.resolutionImages = res.rounds.map(round => round.displayedQuestions[0].listImages[0]);
      //       }
      //       if (res.type === 'resolution') {
      //         this.resolutionImages = res.rounds[this.liveActiveResolution].displayedQuestions.map(question => question.listImages[0]);
      //       }
      // }
      // if (this.resolutionImages != null && this.resolutionImages.length > 0) {
      //   if (res.isLive) {
      //     if (this.resolutionImagesDownloaded[this.liveActiveResolution] == undefined)
      //       getDownloadURL(ref(storage, this.resolutionImages[this.liveActiveResolution])).then((url) => {
      //         this.resolutionImagesDownloaded[this.liveActiveResolution] = url;
      //         this.resolutionImagesDownloaded = Object.assign([], this.resolutionImagesDownloaded);
      //       });
      //   } else {
      //     this.resolutionImages.forEach((elem, index) => {
      //       if (elem != undefined && elem != 'null' && elem.length > 0)
      //       getDownloadURL(ref(storage, elem)).then((url) => {
      //         this.resolutionImagesDownloaded[index] = url;
      //         this.resolutionImagesDownloaded = Object.assign([], this.resolutionImagesDownloaded);
      //       });
      //     });
      //   }
      // }
      // this.isResolution = res.type === 'resolution' || res.type === 'live';
      this.numberOfVote = [];
      this.isLive = res.isLive;
      // this.setupQuestionLists();
      this.participation = Math.round(
        (this.electionDataJson.votes / this.electionDataJson.voters) * 100
      );
      const endDate = res.endDate;

      const options: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric' };
      this.dateString = new Date(endDate).toLocaleDateString(navigator.language, options);
      this.startDate = new Date(res.startDate).toLocaleDateString(navigator.language, options);

      // Format DD/MM/YYYY HH:MM
      const startDateObj = new Date(res.startDate);
      const endDateObj = new Date(endDate);

      const formatDate = (date: Date): string => {
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        return `${day}/${month}/${year} à ${hours}:${minutes}`;
      };

      this.formattedStartDate = formatDate(startDateObj);
      this.formattedEndDate = formatDate(endDateObj);

      this.votingType = res.type;
      if (!this.validationApiBlocker && (this.electionDataJson.is2FA || (this.electionDataJson.password !== null && this.electionDataJson.password.length > 3))) {
        this.validationApiBlocker = true;
        this.setup2FA();
      }

      if (this.electionDataJson.rounds.length > 1 && !this.isLive) {
        this.status = PollStatus.eventList;
      }
      if (res.isFinished) {
        if (res.shareResults) {
          window.location.href = window.location.origin + '/poll/' + this.pollId + '/results';
        }
        else { this.status = PollStatus.completed; }
      }
      this.opened = res.opened;
      if (res.opened  || res.pollPlanningStatus === 'AssessorTesting') {
        this.getVotedStatus();
      }
      this.canHaveTestMode = res.type === 'list';
      if (res.image.length > 0) {
          const logo = document.getElementById('v8te-logo') as HTMLImageElement;
          const link = document.getElementById('v8te-url-image') as HTMLElement;
          if (link) {
            link.removeAttribute('href');
          }
          if (logo) {
            logo.src = res.image;
            logo.style.width = '200px';
            logo.style.maxHeight = '200px';
            logo.style.marginTop = '24px';
          }
      }
    });
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      this.pollId = params.electionId;
      this.validation = params.validation;
    });
    this.isMobile = this.common.checkIfMobile();
    this.route.queryParams.subscribe((params) => {
      this.pollId = params.electionId;
      this.privateKey = params.key;
    });
    this.getPollData();

    this.apiService.getVoterName(this.pollId, this.privateKey).subscribe((res) => {
      this.firstname = res["firstname"];
      this.lastname = res["lastname"];
    }, err => {
      this.isClose = err.error.error === 'Election is closed';
      this.notYetOpen = err.error.error === 'Election is not opened yet';
    });
  }
}

export class AuthError {
  code: number;
  attemptsRemaining: number;
  time: Date;
  constructor(code: number, attemptsRemaining: number, time: Date) {
    this.code = code;
    this.attemptsRemaining = attemptsRemaining;
    this.time = time;
  }
}
